import { Box, Grid, List, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "masterDetail";

export const classes = {
  list: `${PREFIX}-list`,
  detail: `${PREFIX}-detail`,
};

export const MasterDetailWrapper = styled(Box)({
  height: "100%",
  width: "100%",
  display: "flex",
  flex: "1 0 auto",
  [`& .${classes.list}, & .${classes.detail}`]: {
    height: "100%",
    padding: "5px",
    "& > div": {
      height: "100%",
    },
  },
  [`& .${classes.detail}`]: {
    overflow: "auto",
  },
});

export const ListHeader = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "headerHeight",
})(({ headerHeight, theme }) => ({
  height: headerHeight || theme.searchHeight,
}));

export const ListCount = styled(Grid)({
  height: "40px",
  "& p": {
    textTransform: "capitalize",
  },
});

export const ListOfItems = styled(List, {
  shouldForwardProp: (prop) => prop !== "hasSearch" && prop !== "headerHeight",
})(({ hasSearch, headerHeight, theme }) => ({
  width: "100%",
  overflowY: "scroll",
  height: `calc(100% - 40px - ${hasSearch ? `${headerHeight || theme.searchHeight}px` : "0px"})`,
  "& > ul": {
    paddingTop: 0,
  },
}));

export const LowerCase = styled(Typography)({
  textTransform: "lowercase",
});
